import { render, staticRenderFns } from "./MagneticButton.vue?vue&type=template&id=40cb994c&scoped=true"
import script from "./MagneticButton.vue?vue&type=script&lang=js"
export * from "./MagneticButton.vue?vue&type=script&lang=js"
import style0 from "./MagneticButton.vue?vue&type=style&index=0&id=40cb994c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cb994c",
  null
  
)

export default component.exports